import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core"
import { Link } from "gatsby-theme-material-ui"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import OpenInNewIcon from "@material-ui/icons/OpenInNew"
import FileCopyIcon from "@material-ui/icons/FileCopy"
import BookmarkIcon from "@material-ui/icons/Bookmark"
import React, { useEffect, useState } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component"
import { connectRefinementList } from "react-instantsearch-dom"
import { myContext } from "../../../provider"

const popupFields = [
  // { title: "Accno", attrib: "ACCNO" },
  { title: "Title", attrib: "TITLE" },
  { title: "Author", attrib: "AUTHOR" },
  { title: "Publisher", attrib: "Publisher" },
  { title: "City/Town", attrib: "CITY_TOWN" },
  { title: "Province/State", attrib: "PROVINCE_STATE" },
  { title: "Country", attrib: "COUNTRY" },
  { title: "Type", attrib: "TYPE" },
  {
    title: "Year",
    attrib: "YEAR",
    customFunc: attrib =>
      attrib.END ? `${attrib.START} - ${attrib.END}` : attrib.START,
  },
  {
    title: "Language",
    attrib: "Language",
    customFunc: attrib =>
      attrib["1"] +
      (attrib["2"] && `, ${attrib["2"]}`) +
      (attrib["3"] && `, ${attrib["3"]}`),
  },
  { title: "Subject", attrib: "SUBJECT" },
  // { title: "Pages", attrib: "PAGES" },
  { title: "Location", attrib: "LOCATION" },
]

const ResultItem = ({ hit, query }) => {
  const serialNo = `${hit.DDC_NO}/${hit.AUTH_MARK}/${hit.YEAR.START}/${hit.ACCNO}`
  const [serialCopied, setSerialCopied] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const handleClick = () => {
    setExpanded(!expanded)
  }
  useEffect(() => {
    setExpanded(false)
  }, [query])
  return (
    <Accordion expanded={expanded} onChange={handleClick} /* TransitionProps={{ unmountOnExit: true }} */>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        style={{ padding: "0 16px", width: "100%", alignItems: "flex-start" }}
      >
        <Box width="100%">
          <Box display="flex" justifyContent="space-between">
            <Typography
              color="textSecondary"
              variant="overline"
              style={{ fontWeight: 700 }}
            >
              {hit.TYPE}
            </Typography>
            <myContext.Consumer>
              {({ bookmarks, addBookmarks, removeBookmark }) =>
                bookmarks && (
                  <Tooltip
                    title={
                      bookmarks.has(hit.ACCNO)
                        ? "Remove bookmark"
                        : "Bookmark this item"
                    }
                    arrow
                  >
                    <IconButton
                      edge="end"
                      onClick={event => {
                        event.stopPropagation()
                        if (bookmarks.has(hit.ACCNO)) {
                          removeBookmark(hit.ACCNO)
                        } else {
                          addBookmarks(hit.ACCNO)
                        }
                      }}
                      size="small"
                      color={bookmarks.has(hit.ACCNO) ? "primary" : "default"}
                    >
                      <BookmarkIcon />
                    </IconButton>
                  </Tooltip>
                )
              }
            </myContext.Consumer>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="end"
            flexWrap="wrap"
          >
            <Box>
              <Typography variant="h4" color="primary">
                {hit.TITLE}
              </Typography>
              <Typography style={{ fontWeight: 700 }}>{hit.AUTHOR}</Typography>
              <Typography>
                {hit.Publisher}, {hit.CITY_TOWN}, {hit.COUNTRY}, (
                {hit.YEAR.START})
              </Typography>
            </Box>
            <Box pt={2}>
              <Tooltip
                title={
                  serialCopied
                    ? "Serial number copied!"
                    : "Copy serial number to clipboard"
                }
                arrow
              >
                <Chip
                  label={serialNo}
                  size="small"
                  onClick={e => {
                    e.stopPropagation()
                    navigator.clipboard.writeText(serialNo)
                    setSerialCopied(true)
                    setTimeout(() => {
                      setSerialCopied(false)
                    }, 5000)
                  }}
                  style={{ backgroundColor: "#e0e0e0", borderRadius: 16 }}
                />
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box width="100%">
          <TableContainer>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell variant="head" align="right">
                    Serial no:
                  </TableCell>
                  <TableCell style={{ fontWeight: 700 }}>{serialNo}</TableCell>
                </TableRow>
                {popupFields.map(({ title, attrib, customFunc }) => (
                  <TableRow key={title}>
                    <TableCell variant="head" align="right">
                      {title}:
                    </TableCell>
                    <TableCell style={{ fontWeight: 700 }}>
                      {customFunc ? customFunc(hit[attrib]) : hit[attrib]}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            pt={2}
            display="flex"
            justifyContent={"flex-end"}
            alignItems="center"
          >
            <Box display="flex" alignItems="center">
              <Typography style={{ paddingRight: 8, fontWeight: 600 }}>
                Permalink:
              </Typography>
              <TextField
                color="primary"
                variant="outlined"
                size="small"
                defaultValue={`https://sarrc.org.pk/item/#${hit.ACCNO}`}
                InputProps={{
                  readOnly: true,
                }}
              />
              <Tooltip title="Open permalink">
                <IconButton
                  href={`/item/#${hit.ACCNO}`}
                  color="primary"
                  target="_blank"
                >
                  <OpenInNewIcon />
                </IconButton>
              </Tooltip>
              <CopyToClipboard text={`https://sarrc.org.pk/item/#${hit.ACCNO}`}>
                <Tooltip title="Copy link to clipboard">
                  <IconButton color="primary" edge="end">
                    <FileCopyIcon />
                  </IconButton>
                </Tooltip>
              </CopyToClipboard>
            </Box>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default ResultItem
